import { FeatureBadge, Flex, Header, Separator } from '@driftt/dds'
import { Subnav as SideNav } from '@driftt/tide-subnav'
import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'

import { PersonaCard } from 'components/AIConfiguration/LeadQualification/PersonaCard'
import {
  StyledContent,
  StyledHeaderContainer,
} from 'components/PageLayout/PageLayout.styles'
import useAccountAttributes from 'hooks/useAccountAttributes'
import useContactAttributes from 'hooks/useContactAttributes'
import { useGPTQualificationAttributes } from 'hooks/useGPTQualificationAttributes'
import { getSubNavNodes } from 'utils/getSubNavNodes'

import { isEmptyOrNil } from '../../../utils'
import { ConfigLoader } from './ConfigLoader'
import { EmptyStateContainer } from './EmptyStateContainer'

const LeadQualification = () => {
  const {
    data: contactAttributes = [],
    isLoading: isLoadingContactAttributes,
  } = useContactAttributes()
  const { data: accountAttributes = [], isLoading: isLoadingAccAttributes } =
    useAccountAttributes()
  const [sidebarIsOpen, setSidebarIsOpen] = useState(true)
  const { qualificationPersona } = useGPTQualificationAttributes({
    shouldFetchAttributes: true,
  })
  const SUB_NAV_NODES = getSubNavNodes()
  const [shouldAddNewPersona, setShouldAddNewPersona] = useState(false)

  const handlePersonaSave = () => {
    setShouldAddNewPersona(false)
  }

  const hasAttributesConfg =
    !isEmptyOrNil(qualificationPersona) || shouldAddNewPersona

  const isLoading = isLoadingContactAttributes || isLoadingAccAttributes

  return (
    <Flex direction="row" fullWidth fullHeight gap={0}>
      <SideNav
        open={sidebarIsOpen}
        nodes={SUB_NAV_NODES}
        title="Playbooks"
        NavLink={NavLink}
        style={{ height: '100%' }}
        onToggle={() => setSidebarIsOpen(!sidebarIsOpen)}
      />
      <Flex direction="column" gap={0} fullHeight fullWidth>
        <StyledHeaderContainer fullWidth>
          <Flex fullHeight alignItems="center">
            <Header>Qualification rules</Header>
            <FeatureBadge variant="beta" />
          </Flex>
        </StyledHeaderContainer>
        <Separator />
        <StyledContent fullWidth grow={1} overflow>
          {isLoading ? (
            <ConfigLoader />
          ) : hasAttributesConfg ? (
            <Flex direction="column" gap={3}>
              {qualificationPersona && (
                <PersonaCard
                  key={qualificationPersona?.id}
                  persona={qualificationPersona}
                  contactAttributes={contactAttributes}
                  accountAttributes={accountAttributes}
                />
              )}
              {shouldAddNewPersona ? (
                <PersonaCard
                  onPersonaSave={handlePersonaSave}
                  contactAttributes={contactAttributes}
                  accountAttributes={accountAttributes}
                />
              ) : null}
            </Flex>
          ) : (
            <EmptyStateContainer
              onCreatePersona={() => setShouldAddNewPersona(true)}
            />
          )}
        </StyledContent>
      </Flex>
    </Flex>
  )
}

export default LeadQualification
